export default "__VITE_ASSET__8fc32b86__"